import PropTypes from "prop-types";

import Wrapper from "../../helpers/Wrapper";
import { SwiperSlide } from "swiper/react";
import Card from "../Card";
import Slider from "../Slider";
import ComparePostCard from "../ComparePostCard";
import { AllCardDataSample } from "../../../data/cardDataSamples";
import LineLoaderImg from "../../../assets/images/chart-loaders/line.png";
import LineLoaderImgWebp from "../../../assets/images/chart-loaders/line.webp";
import DonutChartLoaderImg from "../../../assets/images/chart-loaders/donut.png";
import DonutChartLoaderImgWebp from "../../../assets/images/chart-loaders/donut.webp";
import SemiDonutChartLoaderImg from "../../../assets/images/chart-loaders/semidonut.png";
import SemiDonutChartLoaderImgWebp from "../../../assets/images/chart-loaders/semidonut.webp";
import SankeyChartLoaderImg from "../../../assets/images/chart-loaders/sankey.png";
import SankeyChartLoaderImgWebp from "../../../assets/images/chart-loaders/sankey.webp";
import StackedChartLoaderImg from "../../../assets/images/chart-loaders/stacked.png";
import StackedChartLoaderImgWebp from "../../../assets/images/chart-loaders/stacked.webp";
import PieChartLoaderImg from "../../../assets/images/chart-loaders/pie.png";
import PieChartLoaderImgWebp from "../../../assets/images/chart-loaders/pie.webp";
import HeatChartLoaderImg from "../../../assets/images/chart-loaders/heat.png";
import HeatChartLoaderImgWebp from "../../../assets/images/chart-loaders/heat.webp";
import TreeChartLoaderImg from "../../../assets/images/chart-loaders/tree.png";
import TreeChartLoaderImgWebp from "../../../assets/images/chart-loaders/tree.webp";
import MapChartLoaderImg from "../../../assets/images/chart-loaders/map.png";
import MapChartLoaderImgWebp from "../../../assets/images/chart-loaders/map.webp";
import BarChartLoaderImg from "../../../assets/images/chart-loaders/bar.png";
import BarChartLoaderImgWebp from "../../../assets/images/chart-loaders/bar.webp";
import SolidGaugeChartLoaderImg from "../../../assets/images/chart-loaders/solidgauge.png";
import SolidGaugeChartLoaderImgWebp from "../../../assets/images/chart-loaders/solidgauge.webp";
import CombinedBarLineChartLoaderImg from "../../../assets/images/chart-loaders/barlinecombined.png";
import CombinedBarLineChartLoaderImgWebp from "../../../assets/images/chart-loaders/barlinecombined.webp";
import TableLoaderImg from "../../../assets/images/chart-loaders/table.png";
import TableLoaderImgWebp from "../../../assets/images/chart-loaders/table.webp";
import GenderLoaderImg from "../../../assets/images/chart-loaders/gender.png";
import GenderLoaderImgWebp from "../../../assets/images/chart-loaders/gender.webp";
import HashLoaderImg from "../../../assets/images/chart-loaders/hash.png";
import HashLoaderImgWebp from "../../../assets/images/chart-loaders/hash.webp";
import CardLoaderImg from "../../../assets/images/chart-loaders/card.png";
import CardLoaderImgWebp from "../../../assets/images/chart-loaders/card.webp";
import ImgLoaderImg from "../../../assets/images/chart-loaders/img.png";
import ImgLoaderImgWebp from "../../../assets/images/chart-loaders/img.webp";
import MultiAxesChartLoaderImg from "../../../assets/images/chart-loaders/multiaxes.png";
import MultiAxesChartLoaderImgWebp from "../../../assets/images/chart-loaders/multiaxes.webp";
import FunnelLoaderImg from "../../../assets/images/chart-loaders/funnel.png";
import FunnelLoaderImgWebp from "../../../assets/images/chart-loaders/funnel.webp";
import BubbleLoaderImg from "../../../assets/images/chart-loaders/bubble.png";
import BubbleLoaderImgWebp from "../../../assets/images/chart-loaders/bubble.webp";
import IndiaMapLoaderImg from "../../../assets/images/chart-loaders/india-map.png";
import IndiaMapLoaderImgWebp from "../../../assets/images/chart-loaders/india-map.webp";
import MultiLineMultiAxisLoaderImg from "../../../assets/images/chart-loaders/multiaxismultiline.png";
import MultiLineMultiAxisLoaderImgWebp from "../../../assets/images/chart-loaders/multiaxismultiline.webp";
import WordCloudLoaderImg from "../../../assets/images/chart-loaders/wordcloud.png";
import WordCloudLoaderImgWebp from "../../../assets/images/chart-loaders/wordcloud.webp";
import PackedCircleLoaderImg from "../../../assets/images/chart-loaders/packedcircle.png";
import PackedCircleLoaderImgWebp from "../../../assets/images/chart-loaders/packedcircle.webp";
const Loader = ({ loaderType, variantType }) => {
  return (
    <Wrapper>
      {loaderType === "cardLoader" ? (
        <Wrapper>
          <div className="grid">
            <div className="card_wrapper">
              {!variantType && (
                <Slider sliderTitle={"Summary"} isSkeleton={true}>
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        key={index}
                        cardTitle={data.label}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        rowOneTitle={"Previous"}
                        numberVariant={"number"}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "compare" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"compare"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "chartCard" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"chartCard"}
                        cardTitle={data.label}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "target" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"target"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "twitter_top_mentions" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"twitter_top_mentions"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "twitter_top_followers" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"twitter_top_followers"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "video_thumbnail" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"video_thumbnail_loader"}
                        cardIconLink={data.brand_logo}
                        cardClass
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
              {variantType === "AdminBucketList" && (
                <Slider
                  sliderTitle={"Brands"}
                  sliderWrapperClass={"tab_card_slider"}
                  isSkeleton={true}
                // showSliderHeader={false}
                >
                  {AllCardDataSample.map((data, index) => (
                    <SwiperSlide key={index}>
                      <Card
                        variant={"AdminBucketList"}
                        showPreviousCompare={true}
                        cardIconLink={data.brand_logo}
                        cardTitle={data.cardTitle}
                        currentValue={data.currentValue}
                        previousValue={data.previousValue}
                        second_currentValue={data.second_currentValue}
                        second_previousValue={data.second_previousValue}
                        rowOneTitle={data.rowOneTitle}
                        rowTwoTitle={data.rowTwoTitle}
                      />
                    </SwiperSlide>
                  ))}
                </Slider>
              )}
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "singleLineChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={LineLoaderImgWebp} type="image/webp" />
                  <source srcSet={LineLoaderImg} type="image/png" />
                  <img src={LineLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "imageLoader" ? (
        <Wrapper>
          <div className="loader_img_wrapper">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={ImgLoaderImgWebp} type="image/webp" />
                    <source srcSet={ImgLoaderImg} type="image/png" />
                    <img src={ImgLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "mapLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="skeleton_map_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  {/* <picture>
                    <source srcSet={MapChartLoaderImgWebp} type="image/webp" />
                    <source srcSet={MapChartLoaderImg} type="image/png" />
                    <img src={MapChartLoaderImg} alt="loader" />
                  </picture> */}
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "multiLineChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={LineLoaderImgWebp} type="image/webp" />
                  <source srcSet={LineLoaderImg} type="image/png" />
                  <img src={LineLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "multiAxisMultiLineChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={MultiLineMultiAxisLoaderImgWebp}
                    type="image/webp"
                  />
                  <source
                    srcSet={MultiLineMultiAxisLoaderImg}
                    type="image/png"
                  />
                  <img src={MultiLineMultiAxisLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "bubbleChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={BubbleLoaderImgWebp} type="image/webp" />
                  <source srcSet={BubbleLoaderImg} type="image/png" />
                  <img src={BubbleLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "treeChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={TreeChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={TreeChartLoaderImg} type="image/png" />
                  <img src={TreeChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "donutChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={DonutChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={DonutChartLoaderImg} type="image/png" />
                  <img src={DonutChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "semiDonutChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={SemiDonutChartLoaderImgWebp}
                    type="image/webp"
                  />
                  <source srcSet={SemiDonutChartLoaderImg} type="image/png" />
                  <img src={SemiDonutChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "sankeyChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={SankeyChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={SankeyChartLoaderImg} type="image/png" />
                  <img src={SankeyChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "stackedColumnChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={StackedChartLoaderImgWebp}
                    type="image/webp"
                  />
                  <source srcSet={StackedChartLoaderImg} type="image/png" />
                  <img src={StackedChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "pieChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={PieChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={PieChartLoaderImg} type="image/png" />
                  <img src={PieChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "heatChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={HeatChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={HeatChartLoaderImg} type="image/png" />
                  <img src={HeatChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "barChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={BarChartLoaderImgWebp} type="image/webp" />
                  <source srcSet={BarChartLoaderImg} type="image/png" />
                  <img src={BarChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "solidGaugeChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={SolidGaugeChartLoaderImgWebp}
                    type="image/webp"
                  />
                  <source srcSet={SolidGaugeChartLoaderImg} type="image/png" />
                  <img src={SolidGaugeChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "combinedBarLineChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source
                    srcSet={CombinedBarLineChartLoaderImgWebp}
                    type="image/webp"
                  />
                  <source
                    srcSet={CombinedBarLineChartLoaderImg}
                    type="image/png"
                  />
                  <img src={CombinedBarLineChartLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "genderLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={GenderLoaderImgWebp} type="image/webp" />
                  <source srcSet={GenderLoaderImg} type="image/png" />
                  <img src={GenderLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "hashLoader" ? (
        <Wrapper>
          <div className="hash_wrapper">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={HashLoaderImgWebp} type="image/webp" />
                    <source srcSet={HashLoaderImg} type="image/png" />
                    <img src={HashLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "funnelChartLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="section_card_chart">
              <div className="loader-chart">
                <picture>
                  <source srcSet={FunnelLoaderImgWebp} type="image/webp" />
                  <source srcSet={FunnelLoaderImg} type="image/png" />
                  <img src={FunnelLoaderImg} alt="loader" />
                </picture>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "smallTableLoader" ? (
        <Wrapper>
          <div className="table_skeleton_loader">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={TableLoaderImgWebp} type="image/webp" />
                    <source srcSet={TableLoaderImg} type="image/png" />
                    <img src={TableLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "indiaMapLoader" ? (
        <Wrapper>
          <div className="skeleton_wrapper">
            <div className="skeleton_map_wrapper">
              <div className="loader-chart">
                {/* <picture>
                  <source srcSet={IndiaMapLoaderImgWebp} type="image/webp" />
                  <source srcSet={IndiaMapLoaderImg} type="image/png" />
                  <img src={IndiaMapLoaderImg} alt="loader" />
                </picture> */}
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "wordCloudLoader" ? (
        <Wrapper>
          <div className="table_skeleton_loader">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source srcSet={WordCloudLoaderImgWebp} type="image/webp" />
                    <source srcSet={WordCloudLoaderImg} type="image/png" />
                    <img src={WordCloudLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "packedCircleLoader" ? (
        <Wrapper>
          <div className="table_skeleton_loader">
            <div className="skeleton_wrapper">
              <div className="section_card_chart">
                <div className="loader-chart">
                  <picture>
                    <source
                      srcSet={PackedCircleLoaderImgWebp}
                      type="image/webp"
                    />
                    <source srcSet={PackedCircleLoaderImg} type="image/png" />
                    <img src={PackedCircleLoaderImg} alt="loader" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "campaignLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <div
            id="campaign_objective_section"
            className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
          >
            <div className="grid col_span_4">
              <div className="section_card_header">
                <h2 className="section_card_title">
                  Objective Wise Distribution
                </h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={PieChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={PieChartLoaderImg}
                              type="image/png"
                            />
                            <img src={PieChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
          </div>
          <div className="section_card section_dropdown_header">
            <div className="grid grid_cols_1">
              <div className="section_card_header">
                <h2 className="section_card_title">Performance By KPI</h2>
              </div>
            </div>
          </div>
          <div
            id="performance_source_section"
            className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
          >
            <div className="grid grid_cols_1">
              <div className="section_card_header">
                <h2 className="section_card_title">Performance By Source</h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="grid col_span_3">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={LineLoaderImgWebp}
                                type="image/webp"
                              />
                              <source srcSet={LineLoaderImg} type="image/png" />
                              <img src={LineLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
              <div className="grid col_span_1">
                <div className="section_card_body">
                  <div className="table_wrapper section_card_table_wrapper">
                    <Wrapper>
                      <div className="table_skeleton_loader">
                        <div className="skeleton_wrapper">
                          <div className="section_card_chart">
                            <div className="loader-chart">
                              <picture>
                                <source
                                  srcSet={TableLoaderImgWebp}
                                  type="image/webp"
                                />
                                <source
                                  srcSet={TableLoaderImg}
                                  type="image/png"
                                />
                                <img src={TableLoaderImg} alt="loader" />
                              </picture>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card">
            <div className="grid col_span_4">
              <div className="section_card_header">
                <h2 className="section_card_title">Summary</h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="section_card_body">
                <Wrapper>
                  <div className="table_skeleton_loader">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={TableLoaderImgWebp}
                              type="image/webp"
                            />
                            <source srcSet={TableLoaderImg} type="image/png" />
                            <img src={TableLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>


          <div className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card">
            <div className="grid col_span_4">
              <div className="section_card_header">
                <h2 className="section_card_title">Planned v/s Delivered Metrics Performance</h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="section_card_body">
                <Wrapper>
                  <div className="table_skeleton_loader">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={BarChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source srcSet={BarChartLoaderImg} type="image/png" />
                            <img src={BarChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>



          <div className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card">
            <div className="grid col_span_4">
              <div className="section_card_header">
                <h2 className="section_card_title">Campaign wise Planned v/s Delivered table</h2>
              </div>
            </div>
            <div className="grid col_span_4">
              <div className="section_card_body">
                <Wrapper>
                  <div className="table_skeleton_loader">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={TableLoaderImgWebp}
                              type="image/webp"
                            />
                            <source srcSet={TableLoaderImg} type="image/png" />
                            <img src={TableLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>


        </Wrapper>
      ) : loaderType === "socialLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Summary"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>

          <Wrapper>
            <div className="grid grid_cols_4 grid_margin_bottom">
              <div
                id="page_views_section"
                className="grid col_span_2 section_card"
              >
                <div className="section_card_header">
                  <h2 className="section_card_title">Page Views</h2>
                </div>
                <div className="grid grid_cols_1 section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={LineLoaderImgWebp}
                                type="image/webp"
                              />
                              <source srcSet={LineLoaderImg} type="image/png" />
                              <img src={LineLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
              <div
                id="page_growth_section"
                className="grid col_span_2 section_card"
              >
                <div className="section_card_header">
                  <h2 className="section_card_title">Page Growth</h2>
                </div>
                <div className="grid grid_cols_1 section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={BarChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={BarChartLoaderImg}
                                type="image/png"
                              />
                              <img src={BarChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="period_source_section"
              className="grid grid_cols_4 fullpage_section_card section_card"
            >
              <div className="grid grid_cols_4">
                <div className="grid col_span_2 card_border_right flex column">
                  <div className="section_card_header">
                    <h2 className="section_card_title">
                      Current Period Source
                    </h2>
                  </div>
                  <div className="grid grid_cols_1 section_card_body">
                    <div className="section_card_chart_wrapper">
                      <Wrapper>
                        <div className="skeleton_wrapper">
                          <div className="section_card_chart">
                            <div className="loader-chart">
                              <picture>
                                <source
                                  srcSet={StackedChartLoaderImgWebp}
                                  type="image/webp"
                                />
                                <source
                                  srcSet={StackedChartLoaderImg}
                                  type="image/png"
                                />
                                <img src={StackedChartLoaderImg} alt="loader" />
                              </picture>
                            </div>
                          </div>
                        </div>
                      </Wrapper>
                    </div>
                  </div>
                </div>
                <div className="grid col_span_2 flex column">
                  <div className="section_card_header">
                    <h2 className="section_card_title">
                      Previous Period Source
                    </h2>
                  </div>
                  <div className="grid grid_cols_1 section_card_body">
                    <div className="section_card_chart_wrapper">
                      <Wrapper>
                        <div className="skeleton_wrapper">
                          <div className="section_card_chart">
                            <div className="loader-chart">
                              <picture>
                                <source
                                  srcSet={StackedChartLoaderImgWebp}
                                  type="image/webp"
                                />
                                <source
                                  srcSet={StackedChartLoaderImg}
                                  type="image/png"
                                />
                                <img src={StackedChartLoaderImg} alt="loader" />
                              </picture>
                            </div>
                          </div>
                        </div>
                      </Wrapper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Wrapper>
        </Wrapper>
      ) : loaderType === "hashtagLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <Wrapper>
            <div className="section_card fullpage_section_card grid grid_margin_bottom">
              <div className="section_card_header">
                <h2 className="section_card_title">Trending Hashtags</h2>
              </div>
              <div className="section_card_body badges_list_wrapper_body">
                <div className="badges_list_wrapper">
                  <Wrapper>
                    <div className="hash_wrapper">
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={HashLoaderImgWebp}
                                type="image/webp"
                              />
                              <source srcSet={HashLoaderImg} type="image/png" />
                              <img src={HashLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>

            <div className="section_card fullpage_section_card grid grid_margin_bottom">
              <div className="section_card_header">
                <h2 className="section_card_title">Hashtag List</h2>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <Wrapper>
                    <div className="table_skeleton_loader">
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={TableLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={TableLoaderImg}
                                type="image/png"
                              />
                              <img src={TableLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
            <div
              id="top_hash"
              className="section_card fullpage_section_card grid grid_margin_bottom"
            >
              <div className="section_card_header">
                <h2 className="section_card_title">Top Hashtags</h2>
              </div>
              <div className="section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={BarChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={BarChartLoaderImg}
                              type="image/png"
                            />
                            <img src={BarChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
          </Wrapper>
        </Wrapper>
      ) : loaderType === "topicLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brands"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>

          <div className="section_card fullpage_section_card grid grid_margin_bottom">
            <div className="section_card_header">
              <h2 className="section_card_title">Topics</h2>
            </div>
            <div className="section_card_body badges_list_wrapper_body">
              <div className="badges_list_wrapper">
                <Wrapper>
                  <div className="hash_wrapper">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={HashLoaderImgWebp}
                              type="image/webp"
                            />
                            <source srcSet={HashLoaderImg} type="image/png" />
                            <img src={HashLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Summary"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>

          <div
            id="world_cloud_section"
            className="grid grid_cols_4 grid_margin_bottom section_card"
          >
            <div className="section_card_header">
              <div className="section_info">
                <h2 className="section_card_title">Overall Conversations</h2>
              </div>
            </div>
            <div className="grid grid_cols_1 section_card_body">
              <div className="section_card_chart_wrapper">
                <div className="grid col_span_4">
                  <div className="grid col_span_3">
                    <div className="section_card_body">
                      <div className="section_card_chart_wrapper">
                        <Wrapper>
                          <div className="skeleton_wrapper">
                            <div className="section_card_chart">
                              <div className="loader-chart">
                                <picture>
                                  <source
                                    srcSet={PackedCircleLoaderImgWebp}
                                    type="image/webp"
                                  />
                                  <source
                                    srcSet={PackedCircleLoaderImg}
                                    type="image/png"
                                  />
                                  <img
                                    src={PackedCircleLoaderImg}
                                    alt="loader"
                                  />
                                </picture>
                              </div>
                            </div>
                          </div>
                        </Wrapper>
                      </div>
                    </div>
                  </div>
                  <div className="grid col_span_1">
                    <div className="section_card_body">
                      <Wrapper>
                        <div className="table_skeleton_loader">
                          <div className="skeleton_wrapper">
                            <div className="section_card_chart">
                              <div className="loader-chart">
                                <picture>
                                  <source
                                    srcSet={TableLoaderImgWebp}
                                    type="image/webp"
                                  />
                                  <source
                                    srcSet={TableLoaderImg}
                                    type="image/png"
                                  />
                                  <img src={TableLoaderImg} alt="loader" />
                                </picture>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Wrapper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="world_cloud_section"
            className="grid grid_cols_4 grid_margin_bottom section_card"
          >
            <div className="section_card_header">
              <div className="section_info">
                <h2 className="section_card_title">Top Things Mentioned</h2>
              </div>
            </div>
            <div className="grid grid_cols_1 section_card_body">
              <div className="section_card_chart_wrapper">
                <Wrapper>
                  <div className="table_skeleton_loader">
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={WordCloudLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={WordCloudLoaderImg}
                              type="image/png"
                            />
                            <img src={WordCloudLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </Wrapper>
              </div>
            </div>
          </div>

          <div className="grid grid_cols_4 grid_margin_bottom">
            <div
              id="mentions_volume_by_source"
              className="grid col_span_2 section_card"
            >
              <div className="section_card_header">
                <h2 className="section_card_title">
                  Mentions Volume By Source
                </h2>
              </div>
              <div className="section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={BarChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={BarChartLoaderImg}
                              type="image/png"
                            />
                            <img src={BarChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>

            <div
              id="mentions_volume_trendline"
              className="grid col_span_2 section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <div className="section_info">
                    <h2 className="section_card_title">
                      Mentions Volume Trendline
                    </h2>
                  </div>
                </div>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={CombinedBarLineChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={CombinedBarLineChartLoaderImg}
                                type="image/png"
                              />
                              <img
                                src={CombinedBarLineChartLoaderImg}
                                alt="loader"
                              />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid_cols_4 grid_margin_bottom">
            <div
              id="Mentions_Volume_By_Day_of_Week"
              className="grid col_span_2 section_card"
            >
              <div className="section_card_header">
                <h2 className="section_card_title">
                  Mentions Volume By Day of Week
                </h2>
              </div>
              <div className="section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={CombinedBarLineChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={CombinedBarLineChartLoaderImg}
                              type="image/png"
                            />
                            <img
                              src={CombinedBarLineChartLoaderImg}
                              alt="loader"
                            />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
            <div
              id="Mentions_Volume_By_Time_of_the_Day"
              className="grid col_span_2 section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <div className="section_info">
                    <h2 className="section_card_title">
                      Mentions Volume By Time of the Day
                    </h2>
                  </div>
                </div>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={BarChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={BarChartLoaderImg}
                                type="image/png"
                              />
                              <img src={BarChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      ) : loaderType === "tvLoader" ? (
        <Wrapper>
          <div className="grid grid_margin_bottom">
            <Slider
              sliderTitle={"Brand Performance Index"}
              sliderWrapperClass={"tab_card_slider"}
              isSkeleton={true}
            // showSliderHeader={false}
            >
              {AllCardDataSample.map((data, index) => (
                <SwiperSlide key={index}>
                  <Card
                    variant={"compare"}
                    showPreviousCompare={true}
                    cardIconLink={data.brand_logo}
                    cardTitle={data.cardTitle}
                    currentValue={data.currentValue}
                    previousValue={data.previousValue}
                    second_currentValue={data.second_currentValue}
                    second_previousValue={data.second_previousValue}
                    rowOneTitle={data.rowOneTitle}
                    rowTwoTitle={data.rowTwoTitle}
                  />
                </SwiperSlide>
              ))}
            </Slider>
          </div>
          <Wrapper>
            <div className="grid grid_margin_bottom">
              <Slider
                sliderTitle={"Performance Metrics"}
                sliderWrapperClass={"tab_card_slider"}
                isSkeleton={true}
              // showSliderHeader={false}
              >
                {AllCardDataSample.map((data, index) => (
                  <SwiperSlide key={index}>
                    <Card
                      variant={"chartCard"}
                      cardTitle={data.label}
                      currentValue={data.currentValue}
                      previousValue={data.previousValue}
                    />
                  </SwiperSlide>
                ))}
              </Slider>
            </div>
            <div
              id="Performance_Trend_Section"
              className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <h2 className="section_card_title">Performance Trend</h2>
                </div>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={CombinedBarLineChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={CombinedBarLineChartLoaderImg}
                                type="image/png"
                              />
                              <img
                                src={CombinedBarLineChartLoaderImg}
                                alt="loader"
                              />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="top_genra_grp_section"
              className="grid grid_cols_2 grid_margin_bottom"
            >
              <div className="grid col_span_1 section_card">
                <div className="section_card_header">
                  <h2 className="section_card_title">Top Genre and GRPs</h2>
                </div>
                <div className="grid grid_cols_1 section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={BarChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={BarChartLoaderImg}
                                type="image/png"
                              />
                              <img src={BarChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>

              <div
                id="ad_duration_wise_grp_section"
                className="grid col_span_1 section_card"
              >
                <div className="section_card_header">
                  <h2 className="section_card_title">AD Duration Wise GRP</h2>
                </div>
                <div className="grid grid_cols_1 section_card_body">
                  <div className="section_card_chart_wrapper">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={BarChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={BarChartLoaderImg}
                                type="image/png"
                              />
                              <img src={BarChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="Brand_Wise_GRP_and_Spends_Section"
              className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header p_b_0 ">
                  <div className="flex column align_start">
                    <h2 className="section_card_title">
                      Brand Wise GRP and Spends
                    </h2>
                  </div>
                </div>
              </div>
              <div className="grid col_span_4">
                <div className="section_card_body">
                  <div className="section_card_chart_wrapper flex column">
                    <Wrapper>
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={TreeChartLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={TreeChartLoaderImg}
                                type="image/png"
                              />
                              <img src={TreeChartLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </Wrapper>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="Ad_Position_Wise_GRP_Section"
              className="grid grid_cols_4 grid_margin_bottom fullpage_section_card section_card"
            >
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <h2 className="section_card_title">Ad Position Wise GRP</h2>
                </div>
              </div>
              <div className="grid col_span_4 section_card_body">
                <div className="section_card_chart_wrapper">
                  <Wrapper>
                    <div className="skeleton_wrapper">
                      <div className="section_card_chart">
                        <div className="loader-chart">
                          <picture>
                            <source
                              srcSet={PieChartLoaderImgWebp}
                              type="image/webp"
                            />
                            <source
                              srcSet={PieChartLoaderImg}
                              type="image/png"
                            />
                            <img src={PieChartLoaderImg} alt="loader" />
                          </picture>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
            <div className="grid grid_cols_4 fullpage_section_card section_card">
              <div className="grid col_span_4">
                <div className="section_card_header">
                  <h2 className="section_card_title">Ad/ Campaign Summary</h2>
                </div>
              </div>
              <div className="grid col_span_4 section_card_body">
                <div className="section_card_body">
                  <Wrapper>
                    <div className="table_skeleton_loader">
                      <div className="skeleton_wrapper">
                        <div className="section_card_chart">
                          <div className="loader-chart">
                            <picture>
                              <source
                                srcSet={TableLoaderImgWebp}
                                type="image/webp"
                              />
                              <source
                                srcSet={TableLoaderImg}
                                type="image/png"
                              />
                              <img src={TableLoaderImg} alt="loader" />
                            </picture>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Wrapper>
                </div>
              </div>
            </div>
          </Wrapper>
        </Wrapper>
      ) : loaderType === "tableLoader" ? (
        <div className="table_wrapper skeleton_wrapper">
          <table className="table">
            <tbody>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
              <tr>
                <td data-label="Name" className="text_align">
                  Win263a84_ind_wpp_263-thums-na_localcampaign-tuicc...
                </td>
                <td data-label="Platform" className="text_align">
                  Instagram
                </td>
                <td data-label="Objective" className="text_align">
                  Outcome_awareness
                </td>
                <td data-label="Spends" className="number_align">
                  ₹5,430,708.66
                </td>
                <td data-label="Impressions" className="number_align">
                  203,828,222
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <Wrapper>
          <div className="loader-wrap">
            <div className="loader_wrapper_new">
              {/* <div className="loader-img"> */}
              <div className="svg-container" style={{ width: "60px" }}>
                <svg width="119" height="60" viewBox="0 0 119 131" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path id="redIcon" d="M7.87003 97.68C5.94003 97.58 3.59003 98.75 2.62003 95.4C1.86003 92.79 2.09003 91.14 4.66003 90.01C5.54003 89.63 6.50003 89.14 7.07003 88.42C7.88003 87.4 8.90003 86.11 8.88003 84.96C8.84003 83 9.14003 80.47 6.12003 79.93C5.18003 79.76 4.32003 79.16 3.38003 78.98C0.310027 78.4 -0.419973 76.69 0.210027 73.73C0.580027 72 1.20003 71.14 2.94003 71C4.00003 70.92 5.04003 70.53 6.10003 70.51C8.47003 70.46 9.67003 69.42 10.42 67.08C11.18 64.72 10.36 63.4 8.67003 62.13C8.13003 61.72 7.64003 61.24 7.14003 60.79C4.50003 58.44 4.38003 56.29 6.90003 53.76C7.35003 53.3 8.27003 53.07 8.94003 53.12C10.09 53.21 11.21 53.62 12.34 53.88C15.9 54.69 18.11 53.64 19.44 50.34C19.69 49.71 19.57 48.81 19.34 48.14C18.93 46.95 18.4 45.78 17.75 44.71C16.5 42.67 16.53 41.17 18.59 39.48C20.55 37.87 22.04 37.72 23.85 39.41C24.56 40.06 25.5 40.47 26.19 41.14C27.97 42.88 29.57 42.17 31.42 41.18C33.28 40.17 33.83 38.82 33.49 36.88C33.36 36.12 33.36 35.33 33.25 34.56C32.94 32.34 33.2 30.78 35.88 29.95C38.46 29.16 39.94 29.68 41.05 31.99C41.43 32.77 42 33.45 42.43 34.21C43.3 35.76 44.33 36.82 46.38 36.36C48.41 35.91 50.8 36.26 51.27 33.3C51.4 32.45 51.85 31.66 52.14 30.84C53.45 27.18 54.73 26.51 58.43 27.88C59.08 28.12 59.7 29 59.93 29.72C60.34 31 60.6 32.37 60.64 33.72C60.71 36.19 62.03 37.15 64.27 37.85C66.54 38.56 67.75 37.65 68.95 36.09C69.42 35.48 70.05 34.97 70.49 34.34C71.87 32.37 73.32 31.93 75.65 33.13C77.95 34.31 78.55 35.67 77.73 37.97C77.44 38.78 77.45 39.72 77.11 40.51C76.09 42.91 77.42 44.16 79.09 45.61C80.85 47.13 82.39 47.38 84.3 46.15C84.95 45.73 85.76 45.57 86.4 45.15C88.55 43.74 90.09 44.04 91.85 46.12C93.64 48.23 93.02 49.64 91.62 51.43C89.88 53.66 87.37 55.95 90.26 58.94C91.14 59.85 92.51 60.4 93.76 60.77C94.63 61.02 95.67 60.65 96.64 60.6C100.18 60.44 101.53 61.62 101.65 65.21C101.67 65.93 101.18 66.85 100.63 67.37C99.8 68.15 98.7 68.66 97.72 69.29C96.11 70.33 94.38 71.09 94.75 73.7C95.12 76.31 95.66 78.42 98.68 78.9C99.34 79 99.95 79.39 100.6 79.56C102.66 80.1 103.92 80.86 103.67 83.54C103.42 86.17 102.51 87.43 99.93 87.58C98.97 87.64 98.01 87.93 97.05 87.98C94.81 88.08 94.01 89.4 93.4 91.41C92.79 93.41 93.11 94.76 94.74 95.95C95.44 96.46 96.01 97.16 96.72 97.67C98.75 99.13 99.22 100.65 97.98 103.1C96.72 105.58 95.08 105.55 92.96 104.93C90.01 104.06 87.23 103.26 85.17 106.82C84.28 108.36 83.87 109.52 84.76 111.06C85.2 111.81 85.41 112.71 85.91 113.41C87.85 116.14 86.95 118.17 84.28 119.51C83.36 119.97 81.97 119.95 80.96 119.64C79.9 119.31 78.98 118.43 78.1 117.67C76.36 116.17 74.81 115.93 72.61 117.14C70.32 118.4 70.02 120.01 70.33 122.18C70.43 122.85 70.45 123.54 70.56 124.21C70.91 126.26 70.53 127.68 68.19 128.42C65.89 129.14 64.08 129.43 62.93 126.8C62.54 125.92 61.82 125.19 61.43 124.31C60.37 121.93 58.46 122 56.31 122.18C54.17 122.36 52.9 123.27 52.44 125.39C52.26 126.23 51.72 127.01 51.59 127.86C51.13 130.82 49.24 131.03 46.72 130.89C43.92 130.74 43.8 128.93 43.53 126.94C43.15 124.1 43.24 120.78 39.13 120.64C37.95 120.6 36.65 121.09 35.58 121.66C34.77 122.09 34.24 123.03 33.59 123.76C30.89 126.77 30.45 126.9 27.1 124.56C26.38 124.06 25.97 122.76 25.89 121.79C25.81 120.78 26.23 119.7 26.55 118.68C27.28 116.36 27.06 114.65 24.86 112.91C22.63 111.14 20.91 111.38 18.83 112.63C18.25 112.98 17.54 113.12 16.99 113.5C14.97 114.9 13.6 114.31 12.09 112.49C10.61 110.71 10.11 109.26 11.87 107.5C12.21 107.16 12.45 106.72 12.72 106.32C13.95 104.46 15.97 102.94 14.05 100.2C12.28 97.67 12.5 97.52 7.87003 97.73V97.68ZM73.34 79.58C73.4 67.89 64.24 58.55 52.68 58.51C41.14 58.47 31.77 67.58 31.68 78.95C31.59 90.68 40.68 100.09 52.19 100.16C63.9 100.24 73.28 91.11 73.33 79.58H73.34Z" fill="#C22428" />
                  <path id="greyIcon" d="M102.56 41.84C102.39 44.62 101.1 45.76 98.25 45.46C97.78 45.41 97.22 44.89 96.95 44.44C96.37 43.47 95.96 42.4 95.47 41.37C94.02 38.33 91.01 37.69 88.48 39.88C88.02 40.28 87.57 40.68 87.11 41.08C84.94 42.97 83.39 42.88 81.52 40.62C81.22 40.25 81.15 39.52 81.26 39.02C81.49 37.99 81.93 37.02 82.28 36.02C83.51 32.44 81.85 29.96 78.12 29.77C77.59 29.74 77.06 29.7 76.53 29.66C73.89 29.43 72.51 27.74 73 25.2C73.09 24.72 73.67 24.23 74.14 23.96C75.12 23.39 76.18 22.97 77.2 22.48C80.04 21.11 80.7 17.99 78.66 15.62C78.26 15.16 77.86 14.71 77.46 14.26C75.44 11.99 75.48 10.72 77.81 8.68001C78.21 8.33001 79.05 8.24001 79.62 8.36001C80.64 8.58001 81.61 9.06001 82.61 9.42001C85.82 10.57 88.74 8.61001 88.88 5.21001C88.9 4.68001 88.88 4.15001 88.92 3.62001C89.07 0.920012 90.62 -0.359988 93.33 0.110012C93.82 0.190012 94.36 0.690012 94.63 1.15001C95.21 2.12001 95.62 3.19001 96.11 4.22001C97.42 6.97001 100.72 7.69001 103.01 5.74001C103.47 5.35001 103.92 4.94001 104.38 4.54001C106.55 2.64001 108.3 2.74001 110 5.00001C110.33 5.44001 110.33 6.28001 110.19 6.87001C109.93 7.97001 109.45 9.01001 109.07 10.08C108.19 12.55 109.94 15.37 112.58 15.69C113.26 15.77 113.94 15.82 114.62 15.86C117.92 16.03 117.86 16.04 118.38 19.3C118.58 20.6 118.16 21.3 116.99 21.75C116.07 22.1 115.19 22.55 114.31 22.98C111.69 24.23 110.97 27.51 112.82 29.73C113.31 30.31 113.76 30.93 114.31 31.44C115.67 32.69 115.94 33.81 114.79 35.54C113.59 37.33 112.42 37.49 110.64 36.71C108.73 36.06 106.68 35.05 104.64 36.8C102.32 38.1 102.59 41.42 102.56 41.87V41.84ZM102.79 23.72C103.32 19.92 100.48 16.22 96.69 15.76C92.94 15.3 89.37 18.02 88.85 21.73C88.31 25.55 91.1 29.2 94.94 29.68C98.67 30.15 102.29 27.4 102.8 23.72H102.79Z" fill="#231F20" />
                </svg>
              </div>
              {/* </div> */}
              <div className="loader-info">
                <p className="info1">Loading Data</p>
                <p>Please wait while we are loading all of your data</p>
              </div>
            </div>
          </div>
        </Wrapper>
      )}
    </Wrapper>
  );
};

Loader.propTypes = {
  loaderType: PropTypes.string,
  variantType: PropTypes.string,
};

export default Loader;
